import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07dc08d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-4" }

import PositionEditor from "./PositionEditor.vue";
import { Subscription } from "@/models/Subscription";
import { Protocol } from "@/models/Protocol";
import { computed, ref } from "vue";
import { Position } from "@/models/Position";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  subscriptionID: { type: String, required: false },
},
  emits: ["changed"],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const props = __props


// eslint-disable-next-line no-undef


const subscription = ref<Subscription>();
const position = ref<Position>();
const editor = ref<PositionEditor>(null);

const fetchBySubscriptionID = async (subID: string): Promise<Subscription> => {
  const sub = await Subscription.fetch(subID);
  if (subID) {
    const prot: Protocol = sub.protocol;
    await prot.fetch();
    const pos = await prot.getPosition(
      sub.contractChain,
      sub.contractAddress,
      sub.positionStatus
    );
    if (!pos) throw "Orphan Subscription - No Position Found";
    subscription.value = sub;
    position.value = pos;
    return sub;
  }
  throw "Invalid Subscription ID";
};
if (props.subscriptionID) {
  (
  ([__temp,__restore] = _withAsyncContext(() => fetchBySubscriptionID(props.subscriptionID))),
  await __temp,
  __restore()
);
} else {
  console.log("No SUBID need to handle NEW case");
  position.value = new Position({}, new Protocol());
}

const irrigate = (s: Subscription): void => {
  if (editor.value) {
    editor.value.irrigate(s);
  }
};

const message = computed((): string => {
  const info = editor.value.message;
  return info;
});

const validSubmit = computed((): boolean => {
  return editor.value.validSubmit;
});

const canComplete = computed((): boolean => {
  return editor.value.canComplete;
});

// eslint-disable-next-line no-undef
expose({ irrigate, message, validSubmit, canComplete });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PositionEditor, {
      ref_key: "editor",
      ref: editor,
      position: position.value,
      showChannels: false,
      showButtons: false,
      showPositionInfo: true,
      showName: false
    }, null, 8, ["position"])
  ]))
}
}

})